/**
 * Generated by Kubb (https://kubb.dev/).
 * Do not edit manually.
 */

import fetch from '../../apiClient'
import type {
  Client,
  RequestConfig,
  ResponseErrorConfig,
} from '../../apiClient'
import type {
  PerformSetCompaniesMutationResponse,
  PerformSetCompaniesPathParams,
  PerformSetCompanies404,
} from '../types/PerformSetCompanies'

function getPerformSetCompaniesUrl({
  import_number,
}: {
  import_number: PerformSetCompaniesPathParams['import_number']
}) {
  const res = {
    method: 'POST',
    url: `/api/v1/importengine/previews/v2/${import_number}/set-companies/` as const,
  }
  return res
}

/**
 * @summary Dispatch the set-companies step for an import preview
 * {@link /api/v1/importengine/previews/v2/:import_number/set-companies/}
 */
export async function performSetCompanies(
  {
    import_number,
  }: { import_number: PerformSetCompaniesPathParams['import_number'] },
  config: Partial<RequestConfig> & { client?: Client } = {}
) {
  const { client: request = fetch, ...requestConfig } = config

  const res = await request<
    PerformSetCompaniesMutationResponse,
    ResponseErrorConfig<PerformSetCompanies404>,
    unknown
  >({
    method: 'POST',
    url: getPerformSetCompaniesUrl({ import_number }).url.toString(),
    ...requestConfig,
  })
  return res.data
}
